import { render, staticRenderFns } from "./wxUser.vue?vue&type=template&id=83c06058&scoped=true&"
import script from "./wxUser.js?vue&type=script&lang=js&"
export * from "./wxUser.js?vue&type=script&lang=js&"
import style0 from "./wxUser.scss?vue&type=style&index=0&id=83c06058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c06058",
  null
  
)

export default component.exports